import APIService from 'services/APIService'

const api = APIService()

/**
 * Universal AI hint endpoint. Call this on debounced text input.
 * Returns 0-3 hint objects with shape { id, kind, label, confidence, payload }.
 *
 * Supported contexts: action_create | task_create | library_pick | file_upload
 */
export const fetchComplianceHints = ({ context, buildingPassportId, payload }) =>
  api.post('/me/compliance/hints', { context, buildingPassportId, payload })
